import { Config } from '@constants';
import { useAuth } from '@hooks/useAuth.tsx';
import { useConfig } from '@hooks/useConfig.tsx';
import { useEffect } from 'react';

const xtremePushUrl = Config.xtremepush;

export const XtremePushScript = () => {
  const { user } = useAuth();
  const { domLoaded } = useConfig();
  useEffect(() => {
    const insertScript = () => {
      const scriptId = 'xtremePushJs';
      if (!document.getElementById(scriptId)) {
        const script = document.createElement('script');
        script.async = true;
        script.id = scriptId;
        script.type = 'text/javascript';
        script.innerHTML = `
          (function(p,u,s,h,e,r,l,i,b) {p['XtremePushObject']=s;p[s]=function(){
            (p[s].q=p[s].q||[]).push(arguments)};i=u.createElement('script');i.async=1;
            i.src=h;b=u.getElementsByTagName('script')[0];b.parentNode.insertBefore(i,b);
          })(window,document,'xtremepush','${xtremePushUrl}');
          `;
        script.onerror = e => {
          console.error('Error loading XtremePush script', e);
        };
        document.head.appendChild(script);
      }
    };

    if (!!user?.validator_status && xtremePushUrl && domLoaded) {
      insertScript();
    }
  }, [user?.validator_status, domLoaded]);

  return null;
};
